
                import { Component } from "/app/packages/open-source/blognami/lib/index.js";
                import { createDecoratorsInclude } from "/app/packages/open-source/blognami/lib/view_file_importers/js.js";
                import { decorators } from "/app/packages/open-source/@blognami/tags/lib/views/_actions/admin/edit_tagable_tags.js";
                const hash = "4cuX9SNIZw";
                Component.include(createDecoratorsInclude(hash, decorators));
            